import { Link } from "react-router-dom";

const Footer = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <>
      <footer className="custom-footer">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="footer-links">
                <div className="links">
                  <ul className="list-inline">
                    <li>
                      <Link to="/staking">Staking</Link>
                    </li>
                    <li>
                      <Link onClick={() => scrollToSection("tokenomics")} to="">
                        Tokenomics
                      </Link>
                    </li>
                    {/* <li>
                      <Link onClick={() => scrollToSection("roadmap")} to="">
                        Roadmap
                      </Link>
                    </li> */}
                    <li>
                      <Link onClick={() => scrollToSection("about")} to="">
                        About us
                      </Link>
                    </li>
                    {/* <li>
                      <Link onClick={() => scrollToSection("ecosys")} to="">
                        Ecosystem
                      </Link>
                    </li> */}
                  </ul>
                </div>
                {/* <div className="social">
                  <h4>Join our community</h4>
                  <ul className="list-inline">
                    <li>
                      <Link to="https://t.me/+3mqTh70FqsE1MTFl">
                        <img src="/images/telegram.png" alt="" />
                      </Link>
                    </li>
                    <li>
                      <Link to="https://x.com/zeussdotone">
                        <img src="/images/twitter.png" alt="" />
                      </Link>
                    </li>
                    <li>
                      <Link to="https://discord.gg/jW76AAP7">
                        <img src="/images/discord.svg" alt="" />
                      </Link>
                    </li>
                  </ul>
                </div> */}
              </div>
              <div className="copyright">
                <div>
                  <h4>TRIBE Token © 2025 . All rights reserved.</h4>
                </div>
                <div className="otherlink">
                  <ul className="list-inline">
                    <li>
                      <Link to="">Terms & Conditions</Link>
                    </li>
                    <li>
                      <Link to="">Privacy Policy</Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};
export default Footer;
